import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { CurecallButton, ECurecallSize } from '@honestica/curecall-ui'
import { getRedirectAfterLoginPath, useSession } from 'src/providers/auth.provider'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'

export const LifenConnectCallbackPage = () => {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const location = useLocation()
  const { completeLifenConnectLogin } = useSession()
  const [hasFailed, setHasFailed] = useState(false)
  // The session-exchange endpoint is single use: React StrictMode must not trigger it twice.
  const hasStartedExchange = useRef(false)

  useEffect(() => {
    if (hasStartedExchange.current || !completeLifenConnectLogin) {
      return
    }
    hasStartedExchange.current = true

    completeLifenConnectLogin()
      .then(() => {
        const redirectPath = getRedirectAfterLoginPath(location.search)
        navigate(redirectPath ?? '/auth/select-project')
      })
      .catch(() => setHasFailed(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (hasFailed) {
    return (
      <div className="c-flex c-flex-col c-gap-6 c-items-center">
        <p className="c-text-danger-500 c-text-center">{t('pages.auth.error.lifen-connect')}</p>
        <CurecallButton size={ECurecallSize.LARGE} onClick={() => navigate('/login')}>
          {t('pages.auth.cta.back-to-connexion-page')}
        </CurecallButton>
      </div>
    )
  }

  return <p className="c-text-center">{t('pages.auth.wording.lifen-connect-loading')}</p>
}
